import React, {FC} from 'react';

import {Colors, Dropdown, Input, Text} from '@optimaxdev/design-system';

import {useGetLocation, DEFAULT_COUNTRY} from 'hooks/location/location';
import {validateField} from 'libs/success/helpers/helpers';
import {DoctorDetailsType} from 'types/successPage';

import s from './doctorManualSearchRegion.scss';

export type PropsType = {
    doctorDetails: DoctorDetailsType;
    onDoctorDetailsChange: (name: string, value: string) => void;
    errors?: {[key: string]: string};
};

/**
 * search region inputs for manually search doctor (TYP CL)
 */
export const DoctorManualSearchRegion: FC<PropsType> = ({
    doctorDetails,
    errors,
    onDoctorDetailsChange,
}) => {
    const {regions} = useGetLocation(DEFAULT_COUNTRY);

    const states = regions ? regions[DEFAULT_COUNTRY] : [];

    return (
        <div className={s.row}>
            <div>
                <Input
                    onChange={({target: {name, value}}: React.ChangeEvent<HTMLInputElement>) =>
                        onDoctorDetailsChange(name, value)
                    }
                    id="city"
                    isError={Boolean(errors?.city)}
                    isSuccess={validateField('city', doctorDetails.city)}
                    label="City"
                    message={errors?.city}
                    name="city"
                    size="large"
                    value={doctorDetails.city}
                    isRequired
                />
            </div>
            <div>
                <Dropdown
                    classes={{
                        container: s.dropdown,
                    }}
                    error={
                        errors?.regionCode && (
                            <Text
                                color={Colors.burnt}
                                lineHeight="18px"
                                margin="4px 0 0"
                                size="12px"
                            >
                                {errors.regionCode}
                            </Text>
                        )
                    }
                    isError={Boolean(errors?.regionCode)}
                    isSuccess={Boolean(doctorDetails.regionCode.trim())}
                    label="State"
                    onClick={value => onDoctorDetailsChange('regionCode', String(value))}
                    options={states}
                    size="large"
                />
            </div>
        </div>
    );
};
